import { from, merge, of } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionBaseInfoAddExpansion } from "../../../info/base/actionBaseInfo";
import { actionInventoryInfoRemoveResource } from "../../../info/inventory/actionInventoryInfo";
import { actionModalCloseAll } from "../../../modals/actionModal";
import { actionOngoingPurchasePremiumDeselect } from "../../../ongoing-purchase/actionOngoingPurchase";
import { actionExpansionsDeselect } from "../actionExpansions";
export var pathBuyExpansion = function (action, state$, deps) {
    var state = state$.value;
    var expansionId = action.expansionId, premium = action.premium;
    if (premium && !state.ongoingPurchase.premium.isConfirmed) {
        return of(actionOngoingPurchasePremiumDeselect());
    }
    return merge(deps
        .netSend({
        id: state.ongoingPurchase.premium.isConfirmed
            ? CommandCode.ExpandFarmGold
            : CommandCode.ExpandFarmResource,
        props: {
            expansionId: expansionId,
            farmId: state.playerBase.base.baseId,
            playerId: state.playerInfo.playerId,
        },
    })
        .pipe(retry(), switchMap(function (res) {
        return from([
            actionBaseInfoAddExpansion(res.expansionId),
            actionInventoryInfoRemoveResource(res.cost),
        ]);
    })), from([
        actionOngoingPurchasePremiumDeselect(),
        actionExpansionsDeselect(),
        actionModalCloseAll(),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/paths/pathBuyExpansion.ts
// module id = 854
// module chunks = 3